const crudName = "MURALS";
export const API_RESET = `API_RESET_${crudName}`;
export const API_ERROR = `API_ERROR_${crudName}`;
export const API_SUCCESS = `API_SUCCESS_${crudName}`;

export const GET_DATA_INDEX = `GET_DATA_INDEX_${crudName}`;
export const SET_DATA_INDEX = `SET_DATA_INDEX_${crudName}`;

export const GET_DATA_SHOW = `GET_DATA_SHOW_${crudName}`;
export const SET_DATA_SHOW = `SET_DATA_SHOW_${crudName}`;

export const DATA_CREATE = `DATA_CREATE_${crudName}`;
export const DATA_EDIT = `DATA_EDIT_${crudName}`;
export const DATA_DELETE = `DATA_DELETE_${crudName}`;
